// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Wl","hoverContainer":"e_Xl","tooltip":"e_Yl","active":"e_Zl","head":"e__l","text":"e_0l"};